import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import APIS from '../../constant/EndPoint';
//@ts-ignore
import { FormLayout } from '@careinfo/layout';
import ComboboxInput from '../Reusable/ComboboxInput';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import TextField from '../Reusable/TextInput';
import { createCombineOrderValidationForm } from '../../utils/validationSchemas';

const CreateManifest = (props: any) => {
  const { handleCreate, isLoading, data } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createCombineOrderValidationForm),
    defaultValues: async () => {
      return {};
    },
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={'Submit'}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-2 gap-x-4 `}>
            <ComboboxInput
              url={APIS.DRIVER}
              queryKey={'driver'}
              register={register('Driver')}
              errors={errors?.driver}
              name={'driver'}
              label={'Driver'}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={'Search Driver'}
              getValues={getValues}
              clearErrors={clearErrors}
            />
            <TextField
              register={register('destination')}
              errors={errors.destination}
              label={'Transport'}
            />
          </div>
          <TextField
            register={register('note')}
            errors={errors.note}
            label={'Note'}
          />
        </div>
      </FormLayout>
    </>
  );
};

export default CreateManifest;
